import Immutable from 'immutable';

const LOAD = 'hynTracker/LOAD';
const LOAD_SUCCESS = 'hynTracker/LOAD_SUCCESS';
const LOAD_FAIL = 'hynTracker/LOAD_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  trackerData: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('trackerData', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error);

    default:
      return state;
  }
}

export const getHynTrackerData = (month, year) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/payReports/hygienists', {
      params: { month, year },
      apiType: 'goApi',
    });
    dispatch({ type: LOAD_SUCCESS, res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};
